import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/events/farmaforum-2025-qbd-group")({
  head: () => buildRouteHead("/en/events/farmaforum-2025-qbd-group", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/events", replace: true });
  },
});
